import { useState } from 'react';
import '../../styles/Home.css';
import Wip from '../../wip';
import STEAMnav from '../../nav/STEAM-Nav';

const STEAM2026 = () => {

  return (





<div className="container">
<STEAMnav ></STEAMnav>
<div>
<h3 className="center-align"><b>STEAM Olympics 2026 - Dallas</b></h3>
</div>

<div><hr class="hr-line"></hr></div>

<div className="row">

<div className="col-sm">

<p className="center-align"><img src="/images/steam/FBT.png" alt="" width="70%" className="rounded" /></p>
</div>

<div className="col-sm">

<p className="center-align"><img src="/images/steam/IWU.png" alt="" width="70%" className="rounded" /></p>
</div>

</div>

<div>
<h5 className="justify c737373"><a href="/"><b>For A Better Tomorrow (FBT)</b></a> and <a href="https://www.iwu.edu/"><b>Illinois Wesleyan University (IWU)</b></a> <b>Proudly Present the 2<sup>nd</sup> Annual STEAM Olympics!. </b></h5>
</div>

<div>
<h5 className="justify c737373">The STEAM Olympics provides a unique opportunity for students of all ages to engage in hands-on experiences, learning, and friendly competition across a variety of STEAM disciplines. Through this event, young thinkers and problem-solvers can delve into subjects that foster creativity, curiosity, and innovation.</h5>
</div>

<p >&nbsp;</p>
<div><hr class="hr-line"></hr></div>

<div className="row">

<div className="col-sm">

<h4 className="center-align"><b >Event Purpose & Impact</b></h4>
<h5 className="justify c737373"><i >STEAM Olympics is more than a competition it's a collaborative effort between FBT and IWU to inspire the next generation while supporting impactful initiatives. Proceeds from this event will help fund scholarships and support grants for projects on both local and global scales. In particular, FBT will award financial need-based scholarships to IWU students involved in the Council of Inclusion and Awareness (CIA), promoting social justice and community engagement.</i></h5>
</div>

</div>

<p >&nbsp;</p>
<div><hr class="hr-line"></hr></div>

<div className="row">

<div className="col-sm">

<h4 className="center-align"><b >Math and Science Debriefs</b></h4>
</div>

</div>

<div className="row">

<div className="col-sm">
<h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/gAKx7s_oHME" role="button">Math Level 1</a></h4>
</div>

<div className="col-sm">
<h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/M-RCEL6sT-U" role="button">Math Level 2</a></h4>
</div>

<div className="col-sm">
<h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/P5h82cMRdoA" role="button">Math Level 3</a></h4>
</div>

</div>

<div className="row">

<div className="col-sm">
<h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/fYCpjrY9YRM" role="button">Science Level 1</a></h4>
</div>

<div className="col-sm">
<h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/vCCkv2ioXzE" role="button">Science Level 2</a></h4>
</div>

<div className="col-sm">
<h4 className="center-align"><a className="btn btn-primary btn-lg " href="https://youtu.be/Gc1CqCsQMvY" role="button">Science Level 3</a></h4>
</div>

</div>

<div><hr class="hr-line"></hr></div>

<div className="row">

<div className="col-sm">

<h4 className="center-align"><b >Event Winners</b></h4>
</div>

</div>

<div ROW>

<div className="col-sm">

<h5 className="center-align"><b className="cRed">Math Test</b></h5>
</div>

</div>

<div className="row">

<table className="table table-bordered">

<thead>

<tr>
<th scope="col"  className="center-align">Level</th>
<th scope="col" className="center-align">Grade</th>
<th scope="col" className="center-align">Gold</th>
<th scope="col" className="center-align">Silver</th>
<th scope="col" className="center-align">Bronze</th>
</tr>

</thead>

<tbody>

<tr>
<td rowspan="3" className="center-align align-middle">Level 1</td>
<td className="center-align align-middle">Grade 1</td>
<td className="center-align">Gary Huang<br/> <span className="c737373">(R. V. Groves Elementary School)</span></td>
<td className="center-align"></td>
<td className="center-align"></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 2</td>
<td className="center-align">Hrehaan Khadgi<br/> <span className="c737373">(Dodd elementary)</span></td>
<td className="center-align">Mithula Maheswaran<br/> <span className="c737373">(Curt singer Elementary)</span><br/>Hari Narayanan<br/> <span className="c737373">(Cockrell Elementary)</span></td>
<td className="center-align"></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 3</td>
<td className="center-align">Ishanth Peddareddygari<br/> <span className="c737373">(Bush Elemetary, Wylie, TX)</span></td>
<td className="center-align">Viona Modi<br/> <span className="c737373">(Willow wood elementary)</span></td>
<td className="center-align"></td>
</tr>

<tr>
<td rowspan="2" className="center-align align-middle">Level 2</td>
<td className="center-align align-middle">Grade 4</td>
<td className="center-align">Ruthvik Boddapu<br/> <span className="c737373">(George Bush Elementry )</span></td>
<td className="center-align">Rithvik Srinivasan<br/> <span className="c737373">(George W. Bush Elementary)</span></td>
<td className="center-align">Arjun Nagavolu<br/> <span className="c737373">(Dodd Elementary)</span></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 5</td>
<td className="center-align">Aaryash Khanijau<br/> <span className="c737373">(Draper Intermediate)</span></td>
<td className="center-align">Dhritman Garg<br/> <span className="c737373">(Davis intermediate)</span></td>
<td className="center-align">Asha Sekar<br/> <span className="c737373">(Cockrell Elementary School)</span></td>
</tr>

<tr>
<td rowspan="3" className="center-align align-middle">Level 3</td>
<td className="center-align align-middle">Grade 6</td>
<td className="center-align">Armaan Anwar<br/> <span className="c737373">()</span></td>
<td className="center-align"></td>
<td className="center-align"></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 7</td>
<td className="center-align">Fahim Mohammed<br/> <span className="c737373">(Frank Mcmillan Junior High)</span></td>
<td className="center-align">Hanshika Somasundaram<br/> <span className="c737373">(Jones Middle School)</span></td>
<td className="center-align">Mia Echols<br/> <span className="c737373">(Cooper Junior High)</span></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 8</td>
<td className="center-align">Advithi Potturi<br/> <span className="c737373">(Argyle Middle School)</span></td>
<td className="center-align">Annette Mathai<br/> <span className="c737373">(Sue Wilson Stafford Middle School)</span></td>
<td className="center-align">Aniksha Gopi<br/> <span className="c737373">(Moseley Middle School)</span></td>
</tr>

</tbody>

</table>

</div>

<div><hr class="hr-line"></hr></div>

<div className="row">

<div className="col-sm">

<h5 className="center-align"><b className="cRed">Science Test</b></h5>
</div>

</div>

<div className="row">

<table className="table table-bordered">

<thead>

<tr>
<th scope="col"  className="center-align">Level</th>
<th scope="col" className="center-align">Grade</th>
<th scope="col" className="center-align">Gold</th>
<th scope="col" className="center-align">Silver</th>
<th scope="col" className="center-align">Bronze</th>
</tr>

</thead>

<tbody>

<tr>
<td rowspan="2" className="center-align align-middle">Level 1</td>
<td className="center-align align-middle">Grade 1</td>
<td className="center-align">Gary Huang<br/> <span className="c737373">(R. V. Groves Elementary School)</span></td>
<td className="center-align"></td>
<td className="center-align"></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 3</td>
<td className="center-align">Ishanth Peddareddygari<br/> <span className="c737373">(Bush Elemetary, Wylie, TX)</span></td>
<td className="center-align">Zoey Mathew<br/> <span className="c737373">()</span></td>
<td className="center-align"></td>
</tr>

<tr>
<td rowspan="2" className="center-align align-middle">Level 2</td>
<td className="center-align align-middle">Grade 4</td>
<td className="center-align">Arjun Nagavolu<br/> <span className="c737373">(Dodd Elementary)</span></td>
<td className="center-align">Ruthvik Boddapu<br/> <span className="c737373">(George W. Bush Elementary)</span></td>
<td className="center-align">Thanvikha Hariharan<br/> <span className="c737373">(George Bush Elementry School)</span></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 5</td>
<td className="center-align">Dhritman Garg<br/> <span className="c737373">(Davis intermediate)</span></td>
<td className="center-align">Aaryash Khanijau<br/> <span className="c737373">(Draper Intermediate)</span></td>
<td className="center-align">Asha Sekar<br/> <span className="c737373">(Cockrell Elementary School)</span></td>
</tr>

<tr>
<td rowspan="2" className="center-align align-middle">Level 3</td>
<td className="center-align align-middle">Grade 7</td>
<td className="center-align">Faizan Harees<br/> <span className="c737373">()</span></td>
<td className="center-align"></td>
<td className="center-align"></td>
</tr>

<tr>
<td className="center-align align-middle">Grade 8</td>
<td className="center-align">Advithi Potturi<br/> <span className="c737373">(Argyle Middle School)</span></td>
<td className="center-align">Aniksha Gopi<br/> <span className="c737373">(Moseley Middle School)</span></td>
<td className="center-align"></td>
</tr>

</tbody>

</table>

</div>

<div><hr class="hr-line"></hr></div>

</div>



  );
}
export default STEAM2026;
